import { iButtonDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Button/Button';
import { iDateBoxDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/DateBox/DateBox';
import propsStore from 'fulogics-ui-web/dist/layout/inspector/propsStore';

export const donePopupValidationGroup = 'donePopupOrderNewValidationGroup';

export const donePopupNewOrderCloseImmediatelyButtonId = 'donePopupNewScreeCloseImmediatelyButton';
const donePopupCloseImmediatelyButtonOptions: iButtonDisplayOptions = {
    id: donePopupNewOrderCloseImmediatelyButtonId,
    //
    type: 'success',
    width: '150px',
    validationGroup: donePopupValidationGroup,
    //
    text: 't~OrderNewScreenDonePopup:closeImmediatelyButton',
};
propsStore.insert(donePopupCloseImmediatelyButtonOptions);

export const donePopupNewOrderCloseDraftButtonId = 'donePopupNewOrderCloseDraftButton';
const donePopupCloseDraftButtonOptions: iButtonDisplayOptions = {
    id: donePopupNewOrderCloseDraftButtonId,
    //
    type: 'success',
    width: '150px',
    //
    text: 't~OrderNewScreenDonePopup:closeDraftButton',
};
propsStore.insert(donePopupCloseDraftButtonOptions);

// export const draftTimeCheckBoxId = 'draftTimeCheckBox'
// const draftTimeCheckBoxOptions : ICheckBoxOptions = {
//     id: "draftTimeCheckBoxId",
//     text: 't~OrderNewScreenDonePopup:checkBoxDateTime'
// }

// iDateBoxDisplayOptions
export const donePopupNewOrderCloseDraftDateBoxId = 'donePopupNewOrderCloseDraftDateBox';
const donePopupCloseDraftDateBoxOptions: iDateBoxDisplayOptions = {
    id: donePopupNewOrderCloseDraftDateBoxId,
    //
    type: 'datetime',
    width: '300px',
    text: 't~OrderNewScreenDonePopup:closeImmediatelyButton',
};
propsStore.insert(donePopupCloseDraftDateBoxOptions);
